export default __webpack_public_path__ + "static/media/team-hands-linked-together.4741422d.jpg";